export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          动画剧场
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          刃牙系列动画化作品全记录，重温经典战斗画面
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          <div className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Anime%20action%20scene%20with%20dramatic%20lighting%2C%20warm%20red%20and%20dark%20background%2C%20Japanese%20animation%20style%2C%20dynamic%20combat%20silhouette%2C%20cinematic%20composition%2C%20no%20text&width=800&height=450&seq=media-01&orientation=landscape"
                alt="刃牙TV第一季重温"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                  <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                </div>
              </div>
              <span className="absolute top-3 right-3 px-2 py-1 rounded bg-black/60 text-white text-xs whitespace-nowrap">24:18</span>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-heading text-foreground-950 mb-1">刃牙TV第一季 经典重温</h3>
              <p className="text-xs text-foreground-400">地下竞技场篇完整动画化</p>
            </div>
          </div>

          <div className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Anime%20style%20dramatic%20scene%20with%20warm%20amber%20lighting%2C%20Japanese%20animation%20aesthetic%2C%20intense%20atmosphere%2C%20cinematic%20composition%2C%20no%20text&width=800&height=450&seq=media-02&orientation=landscape"
                alt="刃牙大擂台赛篇动画"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                  <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                </div>
              </div>
              <span className="absolute top-3 right-3 px-2 py-1 rounded bg-black/60 text-white text-xs whitespace-nowrap">18:55</span>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-heading text-foreground-950 mb-1">刃牙大擂台赛篇动画</h3>
              <p className="text-xs text-foreground-400">中国篇精彩对决全收录</p>
            </div>
          </div>

          <div className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Anime%20style%20dynamic%20battle%20sequence%2C%20warm%20crimson%20and%20dark%20background%2C%20Japanese%20animation%20aesthetic%2C%20speed%20lines%2C%20intense%20action%2C%20no%20text&width=800&height=450&seq=media-03&orientation=landscape"
                alt="范马刃牙动画全集"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                  <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                </div>
              </div>
              <span className="absolute top-3 right-3 px-2 py-1 rounded bg-black/60 text-white text-xs whitespace-nowrap">32:40</span>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-heading text-foreground-950 mb-1">范马刃牙动画全集</h3>
              <p className="text-xs text-foreground-400">Netflix独家系列全面解析</p>
            </div>
          </div>

          <div className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Anime%20OVA%20style%20illustration%20with%20cinematic%20lighting%2C%20warm%20red%20and%20amber%20tones%2C%20Japanese%20animation%20aesthetic%2C%20dramatic%20atmosphere%2C%20no%20text&width=800&height=450&seq=media-04&orientation=landscape"
                alt="刃牙OVA经典回顾"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                  <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                </div>
              </div>
              <span className="absolute top-3 right-3 px-2 py-1 rounded bg-black/60 text-white text-xs whitespace-nowrap">15:32</span>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-heading text-foreground-950 mb-1">刃牙OVA经典回顾</h3>
              <p className="text-xs text-foreground-400">早期动画改编版本全记录</p>
            </div>
          </div>

          <div className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 hover:border-primary-200/60 cursor-pointer">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Anime%20comparison%20style%20split%20screen%20with%20manga%20panels%2C%20warm%20lighting%2C%20Japanese%20animation%20aesthetic%2C%20cinematic%20composition%2C%20no%20text&width=800&height=450&seq=media-05&orientation=landscape"
                alt="刃牙漫画VS动画对比"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                  <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                </div>
              </div>
              <span className="absolute top-3 right-3 px-2 py-1 rounded bg-black/60 text-white text-xs whitespace-nowrap">12:08</span>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-heading text-foreground-950 mb-1">刃牙漫画VS动画对比</h3>
              <p className="text-xs text-foreground-400">名场面动画漫画逐帧对比</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}